import * as React from 'react';
import ImprintContent from './Imprint.Content';

import './Imprint.page.scss';

export interface ImprintProps {
}

export class ImprintPage extends React.Component<ImprintProps, any> {
  public render() {
    return (
      <div className="page-imprint pt-5 pb-5">
        <ImprintContent />
      </div>
    );
  }
}